import { render } from "./dashboard-header.vue?vue&type=template&id=776fd781&scoped=true"
import script from "./dashboard-header.vue?vue&type=script&lang=js"
export * from "./dashboard-header.vue?vue&type=script&lang=js"

import "./dashboard-header.vue?vue&type=style&index=0&id=776fd781&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-776fd781"]])

export default __exports__